import type { ExperimentConfig } from '../@types'

// Both variants are single shared transforms, applied per-appArea on top of each funnel's base
// paywall schema (see web_compliance_jun_2026/__b.ts and __c.ts).
// Each entry has a ready test URL above it (~1 = variant B, ~2 = variant C).
const variantB = () => import('@/modules/Paywall/instances/experiments/web_compliance_jun_2026/__b')
const variantC = () => import('@/modules/Paywall/instances/experiments/web_compliance_jun_2026/__c')

const config: ExperimentConfig[] = [
	{
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_compliance_jun_2026~1
		female: { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_compliance_jun_2026~1
		'activity-female-walking': { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_compliance_jun_2026~1
		'activity-female-tai-chi-walking-v2': { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_compliance_jun_2026~1
		'activity-female-tai-chi-walking-v2-al': { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_compliance_jun_2026~1
		'female-water-fasting': { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=male&exp=web_compliance_jun_2026~1
		male: { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-walking&exp=web_compliance_jun_2026~1
		'activity-male-walking': { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_compliance_jun_2026~1
		'activity-female-tai-chi-walking-pr': { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_compliance_jun_2026~1
		'activity-male-tai-chi-yoga-pr': { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi&exp=web_compliance_jun_2026~1
		'activity-male-chair-tai-chi': { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi-al&exp=web_compliance_jun_2026~1
		'activity-male-chair-tai-chi-al': { paywall: { experiment: variantB } },
	},
	{
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_compliance_jun_2026~2
		female: { paywall: { experiment: variantC } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_compliance_jun_2026~2
		'activity-female-walking': { paywall: { experiment: variantC } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_compliance_jun_2026~2
		'activity-female-tai-chi-walking-v2': { paywall: { experiment: variantC } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_compliance_jun_2026~2
		'activity-female-tai-chi-walking-v2-al': { paywall: { experiment: variantC } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_compliance_jun_2026~2
		'female-water-fasting': { paywall: { experiment: variantC } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=male&exp=web_compliance_jun_2026~2
		male: { paywall: { experiment: variantC } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-walking&exp=web_compliance_jun_2026~2
		'activity-male-walking': { paywall: { experiment: variantC } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_compliance_jun_2026~2
		'activity-female-tai-chi-walking-pr': { paywall: { experiment: variantC } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_compliance_jun_2026~2
		'activity-male-tai-chi-yoga-pr': { paywall: { experiment: variantC } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi&exp=web_compliance_jun_2026~2
		'activity-male-chair-tai-chi': { paywall: { experiment: variantC } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi-al&exp=web_compliance_jun_2026~2
		'activity-male-chair-tai-chi-al': { paywall: { experiment: variantC } },
	},
]

export default config
